import React from 'react'

import noop from 'lodash/noop'

import useUniqueId from '../../hooks/use-unique-id'
import cn from '../../libs/class-names'

export type Props = {
  classNames?: string[]
  id?: string
  name?: string
  value?: string
  label?: React.ReactNode
  error?: boolean
  disabled?: boolean
  rows?: number
  maxLength?: number
  autoFocus?: boolean
  tiny?: boolean
  onChange?: (
    value: string,
    name: string | undefined,
    event: React.ChangeEvent<HTMLTextAreaElement>
  ) => void
  onBlur?: (event: React.FocusEvent<HTMLTextAreaElement>) => void
  onFocus?: (event: React.FocusEvent<HTMLTextAreaElement>) => void
}

const TextField = React.forwardRef<HTMLTextAreaElement, Props>(
  (
    {
      classNames,
      id,
      name,
      label,
      error = false,
      disabled = false,
      value,
      rows,
      maxLength,
      autoFocus = false,
      tiny = false,
      onBlur = noop,
      onFocus = noop,
      onChange = noop,
    }: Props,
    ref
  ) => {
    const actualId = useUniqueId(id)

    return (
      <div className={cn('TextField', {error, disabled, empty: !value, tiny}, classNames)}>
        <textarea
          name={name}
          ref={ref}
          id={actualId}
          className="TextField__input"
          onChange={e => onChange(e.target.value, name, e)}
          value={value}
          autoFocus={autoFocus} // eslint-disable-line jsx-a11y/no-autofocus
          rows={rows}
          disabled={disabled}
          onBlur={onBlur}
          onFocus={onFocus}
          maxLength={maxLength}
        />
        <label htmlFor={actualId} className="TextField__label">
          {label}
        </label>
      </div>
    )
  }
)

TextField.displayName = 'TextField'

export default TextField
